import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import EyezMarketing from './EyezMarketing';
import './index.css';

// eyez v5.2 — front-door routing
// "/" and "/signup*" → marketing site (public)
// everything else → existing app (authenticated)
const path = window.location.pathname;
const isMarketing = path === '/' || path.startsWith('/signup');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(isMarketing ? <EyezMarketing /> : <App />);
